// extracted by mini-css-extract-plugin
export default {"manager-view":"manager-view--Qrxwx","managerView":"manager-view--Qrxwx","manager-view__column":"manager-view__column--GKqvB","managerViewColumn":"manager-view__column--GKqvB"};